// --- FILE: src/utils/formatters.js (FINAL - CON LÓGICA DE ZONA HORARIA MANUAL CONSOLIDADA) ---
import { format as formatDateFns } from 'date-fns';
import { es } from 'date-fns/locale';

// Zona horaria offset para Puerto Rico (UTC-4). NOTA: Esto no maneja Horario de Verano (DST).
const PR_TIMEZONE_OFFSET = -4; 

// Función para convertir UTC Date a hora local de Puerto Rico Date
export const utcToPuertoRicoTime = (utcDate) => {
  const date = new Date(utcDate);
  // getTime() devuelve milisegundos desde epoch UTC
  // getTimezoneOffset() devuelve la diferencia en minutos entre UTC y la hora local del sistema.
  // Multiplicamos por 60000 para convertir a milisegundos.
  const utcTime = date.getTime() + (date.getTimezoneOffset() * 60000); // Convierte a milisegundos UTC
  // Añadimos/restamos el offset de PR para obtener la hora en milisegundos de PR.
  const prTime = new Date(utcTime + (PR_TIMEZONE_OFFSET * 3600000)); // 3600000 ms en una hora
  return prTime;
};

// Función para convertir hora local de Puerto Rico Date a UTC Date
export const puertoRicoTimeToUtc = (prDate) => {
  const date = new Date(prDate);
  const prTime = date.getTime(); // Obtiene milisegundos en la zona horaria del sistema que llamó Date()
  // Restamos/sumamos el offset de PR para obtener milisegundos UTC.
  const utcTime = new Date(prTime - (PR_TIMEZONE_OFFSET * 3600000));
  // Luego restamos el offset local del sistema para obtener el valor UTC puro
  return new Date(utcTime.getTime() - (utcTime.getTimezoneOffset() * 60000));
};

// Función para obtener la hora actual en Puerto Rico (como un objeto Date de JS)
export const getCurrentPRTime = () => {
  return utcToPuertoRicoTime(new Date()); // Convierte la hora UTC actual a la hora de PR
};


export const formatCurrency = (amount) => {
  if (typeof amount !== 'number') {
    amount = 0;
  }
  return new Intl.NumberFormat('es-PR', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

export const formatDuration = (hours) => {
  if (typeof hours !== 'number' || isNaN(hours) || hours < 0) return '0h 0m';
  const h = Math.floor(hours);
  const m = Math.round((hours % 1) * 60);
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

// Formatear fecha/hora en la zona horaria de Puerto Rico (sin date-fns-tz)
// date: puede ser un objeto Date (Firestore Timestamp.toDate())
// dateFormat: string de formato compatible con date-fns (ej. 'dd/MM/yyyy HH:mm')
export const formatDateInPR = (date, dateFormat = 'dd/MM/yyyy HH:mm') => {
  if (!date) return 'N/A';
  let dateObj = date;
  // Si es un Timestamp de Firestore, convertirlo a Date
  if (date && typeof date.toDate === 'function') {
    dateObj = date.toDate();
  }
  // Convertir a la hora de Puerto Rico antes de formatear
  const prDateObj = utcToPuertoRicoTime(dateObj);
  // Usar format de date-fns para formatear la fecha de PR
  return formatDateFns(prDateObj, dateFormat, { locale: es });
};


export const formatTimeUntilCutoff = (cutoffDate) => {
    if (!cutoffDate) return '';
    const now = getCurrentPRTime(); // Usar la hora actual de PR
    const cutoffPR = utcToPuertoRicoTime(cutoffDate); // Convertir la fecha de corte a hora de PR

    if (cutoffPR <= now) return 'Período cerrado';

    const diffMinutes = Math.floor((cutoffPR - now) / 60000);
    const days = Math.floor(diffMinutes / 1440);
    const hours = Math.floor((diffMinutes % 1440) / 60);
    const minutes = diffMinutes % 60;

    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
};

// Función para crear un Date object a partir de una fecha/hora string en timezone de Puerto Rico
// dateStr: fecha en formato 'YYYY-MM-DD'
// timeStr: hora en formato 'HH:mm'
// Retorna un Date object que represente ese momento en Puerto Rico, independientemente de la timezone del navegador
export const createPRDateTime = (dateStr, timeStr) => {
  // Parsear los componentes de la fecha/hora ingresada por el usuario
  const [year, month, day] = dateStr.split('-').map(Number);
  const [hours, minutes] = timeStr.split(':').map(Number);

  // Puerto Rico es UTC-4
  // Si el usuario quiere "2025-11-29 00:00" en PR, eso es "2025-11-29 04:00" en UTC
  // Crear el timestamp UTC equivalente
  const utcTimestamp = Date.UTC(year, month - 1, day, hours + 4, minutes, 0, 0);

  // Retornar un Date object con ese timestamp
  return new Date(utcTimestamp);
};